import PagamentoLoteDashboardComponent from "../../components/pagamento-lote/dashboard/PagamentoLoteDashboard";

export default function PagamentoLoteDashboard() {
  return <PagamentoLoteDashboardComponent />;
}
